import axios from 'axios';
import {toast} from 'react-toastify';
import {useAuthStore} from '../store';

export const apiClient = axios.create({
  baseURL: 'https://mapex.fun/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    try {
      const {token} = useAuthStore.getState();
      config.headers['Authorization'] = `Bearer ${token}`;
    } finally {
      return config;
    }
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Error:', error.response);
    const errorMessage = error.response?.data?.message;
    if (errorMessage) {
      toast.error(errorMessage);
    } else {
      const errors = error.response?.data?.errors || [];
      errors.map((error) => error.msg && toast.error(error.msg));
    }
    return Promise.reject(error);
  },
);
